// extracted by mini-css-extract-plugin
module.exports = {"sidebarChat":"SidebarChat_sidebarChat__cjcjP","sidebarChat__info":"SidebarChat_sidebarChat__info__3gN1J"};